import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { TitleOfferLightFragmentDoc } from '../../../buybox/graphql/fragments/Offer.fragment';
export type AdServerQtvSimilarTitleFragment = {
	__typename: 'AdSimilarTitle';
	id: string;
	objectId: number;
	objectType: Types.ObjectType;
	similarityScore: number;
	content: {
		__typename: 'AdSimilarTitleContent';
		title: string;
		posterUrl?: string | null;
		fullPath: string;
		scoring?: { __typename: 'Scoring'; imdbScore?: number | null } | null;
	};
	offers: Array<{
		__typename: 'Offer';
		id: string;
		monetizationType: Types.MonetizationType;
		presentationType: Types.PresentationType;
		standardWebURL?: string | null;
		package: {
			__typename: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			icon: string;
			iconWide: string;
			maskReferrer?: boolean | null;
			technicalName: string;
		};
	}>;
};

export const AdServerQtvSimilarTitleFragmentDoc = gql`
	fragment AdServerQtvSimilarTitle on AdSimilarTitle {
		id
		objectId
		objectType
		similarityScore
		content {
			title
			posterUrl
			fullPath
			scoring {
				imdbScore
				__typename
			}
			__typename
		}
		offers(country: $country, platform: $platform) {
			...TitleOfferLight
			__typename
		}
		__typename
	}
	${TitleOfferLightFragmentDoc}
`;
